var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12C24.4183 12 28 15.5817 28 20C28 24.4183 24.4183 28 20 28C15.5817 28 12 24.4183 12 20C12 15.5817 15.5817 12 20 12ZM22.4657 16.2602L20 18.727L17.5357 16.2602C17.1842 15.9088 16.6144 15.9088 16.2629 16.2602C15.9114 16.6117 15.9114 17.1815 16.2629 17.533L18.728 20.001L16.2629 22.47C15.9114 22.8215 15.9114 23.3913 16.2629 23.7428C16.6144 24.0943 17.1842 24.0943 17.5357 23.7428L20 21.275L22.4657 23.7428C22.8172 24.0943 23.387 24.0943 23.7385 23.7428C24.09 23.3913 24.09 22.8215 23.7385 22.47L21.272 20.001L23.7385 17.533C24.09 17.1815 24.09 16.6117 23.7385 16.2602C23.387 15.9088 22.8172 15.9088 22.4657 16.2602Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedClose);
export default __webpack_public_path__ + "static/media/rounded-close.96cfbaffb1551d00896201ae9ee6afc8.svg";
export { ForwardRef as ReactComponent };